// ═══════════════════════════════════════════════════════════════════
//  modules/luckperms/LpPanier.js
//  La barre du bas : ce qui va partir, et le bouton qui l'envoie.
//  Rien n'est exécuté tant qu'on n'a pas cliqué ici.
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { THEME } from "../../socle/theme";
import { libelleValeur, commandeDe } from "./api";

export function LpPanier({
  changements, grades, etat, onVider, onRetirer, onAppliquer,
  enCours, resultat, onFermerResultat, isMobile,
}) {
  const [ouvert, setOuvert] = useState(false);
  const [motif, setMotif] = useState("");

  const nomGrade = (c) => (grades.find((g) => g.cle === c) || {}).libelle || c;

  // ── Après envoi : le compte rendu, et ce qui n'est pas passé ──
  if (resultat) {
    const rates = (resultat.resultats || []).filter((r) => r.statut !== "ok");
    const refus = resultat.refus || [];
    return (
      <div style={barre}>
        <div style={{ ...contenu, flexDirection: "column", alignItems: "stretch", gap: 8 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <b style={{ color: resultat.echecs ? THEME.red : THEME.emerald, fontSize: 14 }}>
              {resultat.applique} commande(s) appliquée(s)
              {resultat.sans_effet ? ` · ${resultat.sans_effet} sans effet` : ""}
              {resultat.echecs ? ` · ${resultat.echecs} échec(s)` : ""}
            </b>
            <span style={{ color: THEME.textDim, fontSize: 12.5 }}>
              lot {resultat.lot} · envoyé sur {resultat.serveur}
            </span>
            <span style={{ flex: 1 }} />
            <button style={btnPri} onClick={onFermerResultat}>Fermer</button>
          </div>

          {(rates.length > 0 || refus.length > 0) && (
            <div style={{ maxHeight: 180, overflow: "auto", fontSize: 12.5 }}>
              {refus.map((r, i) => (
                <div key={`r${i}`} style={{ color: THEME.amber, padding: "2px 0" }}>
                  refusé — <code>{r.node}</code> / {nomGrade(r.grade)} : {r.raison}
                </div>
              ))}
              {rates.map((r, i) => (
                <div key={`e${i}`} style={{ color: r.statut === "echec" ? THEME.red : THEME.textMuted, padding: "2px 0" }}>
                  {r.statut} — <code>{r.commande}</code> → {r.reponse || "(pas de réponse)"}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  if (!changements.length) return null;

  return (
    <div style={barre}>
      <div style={contenu}>
        <span style={{ color: THEME.text, fontSize: 14, fontWeight: 600 }}>
          {changements.length} changement{changements.length > 1 ? "s" : ""} en attente
        </span>
        {!isMobile && (
          <span style={{ color: THEME.textDim, fontSize: 12.5 }}>
            rien n'est parti sur le serveur
          </span>
        )}
        <span style={{ flex: 1 }} />
        <input
          value={motif}
          onChange={(e) => setMotif(e.target.value)}
          placeholder="Motif (facultatif, va dans le journal)"
          style={{
            background: THEME.surface, border: `1px solid ${THEME.border}`,
            borderRadius: 7, color: THEME.text, padding: "6px 10px",
            fontSize: 13, minWidth: isMobile ? 140 : 230, flex: isMobile ? 1 : "none",
          }}
        />
        <button style={btn} onClick={() => setOuvert(!ouvert)}>
          {ouvert ? "Replier" : "Détail"}
        </button>
        <button style={btn} onClick={onVider} disabled={enCours}>Annuler</button>
        <button
          style={{ ...btnPri, opacity: enCours ? 0.6 : 1 }}
          onClick={() => onAppliquer(motif)}
          disabled={enCours}
        >
          {enCours ? "Envoi en cours…" : `Appliquer les ${changements.length}`}
        </button>
      </div>

      {ouvert && (
        <div style={{ maxHeight: 260, overflow: "auto", borderTop: `1px solid ${THEME.border}` }}>
          {changements.map((c, i) => {
            const avant = ((etat[c.node] || {})[c.grade] || {}).v || "unset";
            return (
              <div key={i} style={{
                display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap",
                padding: "6px 20px", borderBottom: `1px solid ${THEME.border}`,
                fontSize: 12.5, maxWidth: 1240, margin: "0 auto",
              }}>
                <code style={{ color: THEME.accent, minWidth: 220 }}>{c.node}</code>
                <span style={{ color: THEME.textMuted, minWidth: 86 }}>{nomGrade(c.grade)}</span>
                <span style={{ color: THEME.textDim }}>
                  {libelleValeur(avant)} → <b style={{ color: THEME.text }}>{libelleValeur(c.valeur)}</b>
                </span>
                <span style={{ flex: 1 }} />
                {!isMobile && (
                  <code style={{ color: THEME.textDim, fontSize: 11.5 }}>
                    {commandeDe(c.node, c.grade, c.valeur)}
                  </code>
                )}
                <button onClick={() => onRetirer(c.node, c.grade)} style={{ ...btn, padding: "2px 8px", fontSize: 11 }}>
                  retirer
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const barre = {
  position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 40,
  background: THEME.surface, borderTop: `1px solid ${THEME.border}`,
  boxShadow: "0 -8px 30px rgba(0,0,0,.45)",
};
const contenu = {
  display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap",
  padding: "10px 20px", maxWidth: 1240, margin: "0 auto",
};
const btn = {
  background: THEME.panel, border: `1px solid ${THEME.border}`, color: THEME.text,
  borderRadius: 7, padding: "6px 12px", fontSize: 13, cursor: "pointer",
};
const btnPri = {
  background: THEME.accent, border: `1px solid ${THEME.accent}`, color: "#fff",
  borderRadius: 7, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer",
};
